import template from './sw-cms-el-acris-faq.html.twig';
import './sw-cms-el-acris-faq.scss';

const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-acris-faq', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    computed: {
        faqElements() {
            return this.element.config.faqGroups.value;
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-faq');
            this.initElementData('acris-faq');
        },
    }
});
